import { PaperclipIcon, EmojiIcon, MicIcon } from "./icons";

export function ChatComposer() {
  return (
    <div className="flex items-center gap-3 px-3.5 py-2.5 bg-tg-window border-t border-tg-border shrink-0 text-tg-icon">
      <PaperclipIcon />
      <div className="flex-1 text-[14.5px] text-tg-text-muted">Message</div>
      <EmojiIcon />
      <MicIcon />
    </div>
  );
}
